import { render, staticRenderFns } from "./CreateOrderPage.vue?vue&type=template&id=757e7e3b&scoped=true&"
import script from "./CreateOrderPage.vue?vue&type=script&lang=js&"
export * from "./CreateOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrderPage.vue?vue&type=style&index=0&id=757e7e3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757e7e3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757e7e3b')) {
      api.createRecord('757e7e3b', component.options)
    } else {
      api.reload('757e7e3b', component.options)
    }
    module.hot.accept("./CreateOrderPage.vue?vue&type=template&id=757e7e3b&scoped=true&", function () {
      api.rerender('757e7e3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/CreateOrderPage.vue"
export default component.exports